import * as _EnvironmentUtils from "./env";
import * as FetchUtils from "./fetch";
import { WSClient as _WSClient } from "./websocket";
import { InfaceSDK as _InfaceSDK } from "./inface_sdk";
import { SDKError as _SDKError } from "./inface_sdk/sdk_error";
import _lodash from "lodash";
import { getModuleApi as _getModuleApi } from "./inface_sdk/get-module-api";
import * as _ConfigUtils from "./config";

import {
  loadModulePath as _loadModulePath,
  requireNative as _requireNative,
  loadModulePath_x86_64 as _loadModulePath_x86_64,
  loadModulePath_i686 as _loadModulePath_i686,
  generateUUID as _generateUUID,
  ITC as _itc
} from "./utils";

import common from './common'

export const InfaceEnv = _EnvironmentUtils;
export const Fetch = FetchUtils.Fetch;
export const WSClient = _WSClient;
export const InfaceSDK = _InfaceSDK;
export const lodash = _lodash;
export const loadModulePath = _loadModulePath;
export const requireNative = _requireNative;
export const loadModulePath_x86_64 = _loadModulePath_x86_64;
export const loadModulePath_i686 = _loadModulePath_i686;
export const generateUUID = _generateUUID;
export const SDKError = _SDKError;
export const getModuleApi = _getModuleApi;
export const InfaceConfig = _ConfigUtils;
export const ITC = _itc

if (!window.inface) {
  window.inface = {}
}

window.inface.common = common

window.InfaceCommon = common

export default common